import Route from "../../../router/Route";
import { RouteLocationNormalized, RouterView } from "vue-router";

import Index from "../pages/Index.vue";
import GeneralSettingsTab from "@/modules/profile/components/GeneralSettingsTab.vue";
import NotificationPreference from "@/modules/profile/components/NotificationPreference.vue";
import NotificationEvents from "@/modules/profile/components/NotificationEvents.vue";
import ColorPalettesTab from "@/ui/components/colorPalette/ColorPalettesTab.vue";
import ColorPaletteEdit from "@/ui/components/colorPalette/ColorPaletteEdit.vue";

export default new Route("profile", "/profile", RouterView, [
	new Route(
		"profile.index",
		":uuid",
		Index,
		[
			new Route("profile.general", "general-settings", GeneralSettingsTab, []),
			new Route(
				"profile.notifications",
				"notification-settings",
				NotificationPreference,
				[],
				{
					permissions: ["can_user_update_own_notification_preference"],
				}
			),
			new Route(
				"profile.notification.events",
				"notification-events",
				NotificationEvents,
				[],
				{
					permissions: ["can_user_update_own_notification_preference"],
				}
			),
			new Route(
				"profile.colorPalettes",
				"color-palettes",
				ColorPalettesTab,
				[],
				{},
				"",
				[],
				{ scope: "personal" }
			),
			new Route(
				"profile.colorPalettes.edit",
				"color-palettes/:palette_uuid",
				ColorPaletteEdit,
				[],
				{},
				"",
				[],
				{ scope: "personal" }
			),
		],
		{},
		(to: RouteLocationNormalized): string => {
			return `/profile/${to.params.uuid}/general-settings`;
		}
	),
]);
